function FileuploadDirective(Upload, SweetAlert, fileSystem, platform, authService, $timeout, $sce) {
    "ngInject";

    return {
        restrict: 'EA',
        require: 'ngModel',
        scope: {
            'ocomFileUpload': '@',
            'otherId': '=',
            'otherName': '@',
            'userId': '=',
            'ngModel': '=',
            'disableDownload': "=?",
            'imagesOnly': '=?',
            'clearOnUpload': '=?',
            'uploadComplete': "&?",
            'uploadImmediately': "=?"
        },
        templateUrl: '/app/filesystem/fileupload.directive.html',
        link: function ($scope, iElement, iAttrs, ngModelCtrl) {
            $scope.disableDownload = $scope.disableDownload || false;

            $scope.file = null;
            $scope.loading = null;

            $scope.$watch('imagesOnly', function (newValue) {
                if (newValue) {
                    $scope.pattern = "image/*";
                    $scope.accept = "image/*";
                    $scope.capture = "camera";
                }
                else {
                    $scope.pattern = "";
                    $scope.accept = "";
                    $scope.capture = "other";
                }
            });

            $scope.clearOnUpload = $scope.clearOnUpload || false;

            $scope.$watch("ngModel", function (newVal, oldVal) {
                $scope.file = newVal;
            });

            $scope.getDownloadURL = function(inline) {
                if ($scope.file) {
                    return $sce.trustAsResourceUrl("/filesystem/download/" + $scope.file.id + "/?download=" + (!inline));
                }
                else {
                    return "";
                }
            };

            $scope.removeFile = function() {
                $scope.file = null;
                $scope.loading = null;
                ngModelCtrl.$setViewValue(null);
            };

            $scope.uploadNow = false;
            $scope.selected = function ($files) {
                if ($scope.uploadImmediately || $scope.uploadNow) {
                    if ($scope.uploadNow)
                        $scope.uploadNow = false; // reset to false as we have uploaded

                    _.each($files, function (file) {
                        $scope.upload(file); // upload the file..
                    });
                }
            };

            $scope.upload = function (file) {
                if (!file) {
                    $scope.uploadNow = true; // do it right away
                    $("input[type='file']", iElement).trigger('click');
                    return
                }

                $scope.loading = {message: "Starting upload", percent: 0, ok: true};

                Upload.upload({
                    url: '/filesystem/upload',
                    data: {file: file, 'userId': $scope.userId, 'other_id':$scope.otherId, 'other_name': $scope.otherName}
                }).then(function (resp) {
                    $scope.loading.percent = 100;
                    $scope.loading.message = 'Success ' + resp.config.data.file.name + ' uploaded.';

                    $scope.file = null; // Reset for new file..

                    ngModelCtrl.$setViewValue(resp.data);

                    $timeout(function () {
                        if ($scope.clearOnUpload) {
                            $("input[type='file']", iElement).val("");
                            if ($scope.uploadComplete) {
                                $scope.uploadComplete(resp.data);
                            }
                        }

                        $scope.loading = null;  // clear loading message
                    }, 600);
                }, function (resp) {
                    $scope.loading.ok = false;
                    $scope.loading.message = 'Error status: ' + resp.status;
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);

                    $scope.loading.percent = progressPercentage;
                    $scope.loading.message = 'Progress: ' + progressPercentage + '% ' + evt.config.data.file.name;
                });
            };
        }
    };
}

export default FileuploadDirective;

